import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { TickerRibbon } from "@/components/site/TickerRibbon";
import { Steps } from "@/components/site/Steps";
import { Services } from "@/components/site/Services";
import { WhyUs } from "@/components/site/WhyUs";
import { ServiceArea } from "@/components/site/ServiceArea";
import { RequestForm } from "@/components/site/RequestForm";
import { Footer } from "@/components/site/Footer";

export default function FuelHero() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80 });
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div data-testid="fuel-hero-page" className="bg-[#FAFAFA]">
      <Navbar />
      <main>
        <Hero />
        <TickerRibbon />
        <Steps />
        <Services />
        <WhyUs />
        <ServiceArea />
        <RequestForm />
      </main>
      <Footer />
    </div>
  );
}
